export const Material_data = [
    {
        "id": 1,
        "name": "Basket Weave : Milk",
        "diffuse": "../textures/fabric-basket_weave-milk.jpg",
        "repeat": [
            15,
            22.94455067
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 1,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.7,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Retreat_Fabrics",
            "Cushion",
            "Headboard_Fabric"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 22,
        "name": "Fireworks : Wild Salmon",
        "diffuse": "../textures/fabric-fireworks-wild_salmon.jpg",
        "repeat": [
            26,
            13
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 22,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 3,
        "name": "Beach House Linen : Peacock",
        "diffuse": "../textures/fabric-beach_house_linen-peacock.jpg",
        "repeat": [
            17.1428571428571,
            25.9179265658747
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 3,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Retreat_Fabrics",
            "Cushion",
            "Headboard_Fabric"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 4,
        "name": "Beach House Linen : Vast Sky",
        "diffuse": "../textures/fabric-beach_house_linen-vast_sky.jpg",
        "repeat": [
            17.1428571428571,
            25.8064516129032
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 4,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Retreat_Fabrics",
            "Cushion",
            "Headboard_Fabric"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 32,
        "name": "Knotty Loop : Academy",
        "diffuse": "../textures/fabric-knotty_loop-academy.jpg",
        "repeat": [
            24,
            27.8422273781903
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 32,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion",
            "Headboard_Fabric"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 5,
        "name": "Boats By The Yard : Gladiola",
        "diffuse": "../textures/fabric-boats_by_the_yard-gladiola.jpg",
        "repeat": [
            4.8,
            4.44444444444444
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 5,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 11,
        "name": "Cast-A-Net : Lagoon",
        "diffuse": "../textures/fabric-cast-a-net-lagoon.jpg",
        "repeat": [
            8,
            10
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 11,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 7,
        "name": "Boomerang: Sage",
        "diffuse": "../textures/fabric-boomerang-sage.jpg",
        "repeat": [
            7,
            7
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 7,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 9,
        "name": "Branch Out : Peacock",
        "diffuse": "../textures/fabric-branch_out-peacock.jpg",
        "repeat": [
            4.8,
            4.44444444444444
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 9,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 12,
        "name": "Cast-A-Net : Marine",
        "diffuse": "../textures/fabric-cast-a-net-marine.jpg",
        "repeat": [
            8,
            10
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 12,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 13,
        "name": "Checkmate : Denim",
        "diffuse": "../textures/fabric-checkmate-denim.jpg",
        "repeat": [
            6,
            5.71428571428572
        ],
        "offset": [
            0.2,
            0
        ],
        "uuid": 13,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 14,
        "name": "Checkmate : Sour Apple",
        "diffuse": "../textures/fabric-checkmate-sour-apple.jpg",
        "repeat": [
            6,
            5.71428571428572
        ],
        "offset": [
            0.02,
            0
        ],
        "uuid": 14,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 15,
        "name": "Clambake: Bluebell",
        "diffuse": "../textures/fabric-clambake-bluebell.jpg",
        "repeat": [
            4.44444444444444,
            4.44444444444444
        ],
        "offset": [
            0.1,
            0.47
        ],
        "uuid": 15,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 17,
        "name": "Clambake: Sprout",
        "diffuse": "../textures/fabric-clambake-sprout.jpg",
        "repeat": [
            4.44444444444444,
            4.44444444444444
        ],
        "offset": [
            0.1,
            0.47
        ],
        "uuid": 17,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 18,
        "name": "Crazy Daisy : Nikko Blue",
        "diffuse": "../textures/fabric-craisy_daisy-nikko_blue.jpg",
        "repeat": [
            12,
            10
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 18,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 19,
        "name": "Crazy Daisy : Wild Salmon",
        "diffuse": "../textures/fabric-craisy_daisy-wild_salmon.jpg",
        "repeat": [
            12,
            10
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 19,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 20,
        "name": "Dilly : Bluebell",
        "diffuse": "../textures/fabric-dilly-bluebell.jpg",
        "repeat": [
            6.66666666666667,
            6.66666666666667
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 20,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 29,
        "name": "Hydrangea Holiday : Bluestone",
        "diffuse": "../textures/fabric-hydrangea_holiday-bluestone.jpg",
        "repeat": [
            4.8,
            4.8
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 29,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 26,
        "name": "Grand Mum : Oyster",
        "diffuse": "../textures/fabric-grand_mum-oyster.jpg",
        "repeat": [
            4.44444444444444,
            4.44444444444444
        ],
        "offset": [
            4.53,
            -1.08
        ],
        "uuid": 26,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 27,
        "name": "Grand Mum : Sun",
        "diffuse": "../textures/fabric-grand_mum-sun.jpg",
        "repeat": [
            4.44444444444444,
            4.44444444444444
        ],
        "offset": [
            4.53,
            -1.08
        ],
        "uuid": 27,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 28,
        "name": "Hotty Dotty : Ale",
        "diffuse": "../textures/fabric-hotty_dotty-ale.jpg",
        "repeat": [
            8.88888888888889,
            8.88888888888889
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 28,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 31,
        "name": "In Stitches : Bluebell",
        "diffuse": "../textures/fabric-institches-bluebell-w4h6_old.jpg",
        "repeat": [
            12,
            8
        ],
        "offset": [
            0.11,
            0
        ],
        "uuid": 31,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 34,
        "name": "Knotty Loop : Marine",
        "diffuse": "../textures/fabric-knotty_loop-marine.jpg",
        "repeat": [
            24,
            27.8422273781903
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 34,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Retreat_Fabrics",
            "Cushion",
            "Headboard_Fabric"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 35,
        "name": "Laguna : Marine",
        "diffuse": "../textures/fabric-laguna-marine.jpg",
        "repeat": [
            7,
            4
        ],
        "offset": [
            0.2,
            -1.46
        ],
        "uuid": 35,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion",
            "Headboard_Fabric"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 36,
        "name": "Laguna : Pear",
        "diffuse": "../textures/fabric-laguna-pear.jpg",
        "repeat": [
            7,
            4
        ],
        "offset": [
            0.47,
            -1.46
        ],
        "uuid": 36,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion",
            "Headboard_Fabric"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 10,
        "name": "Cast-A-Net : Wheatgrass",
        "diffuse": "../textures/fabric-cast-a-net_wheatgrass.jpg",
        "repeat": [
            8,
            10
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 10,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 2,
        "name": "Basket Weave : Vast Sky",
        "diffuse": "../textures/fabric-basket_weave-vast_sky.jpg",
        "repeat": [
            15,
            25.3699788583509
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 2,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion",
            "Headboard_Fabric"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 25,
        "name": "Freckles : Zinnia",
        "diffuse": "../textures/fabric-freckles-zinnia.jpg",
        "repeat": [
            6,
            6
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 25,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Retreat_Fabrics",
            "Cushion",
            "Headboard_Fabric"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": "../textures/fabric-freckles-normal.jpg",
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 6,
        "name": "Boomerang : Cloud",
        "diffuse": "../textures/fabric-boomerang-cloud.jpg",
        "repeat": [
            7,
            7
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 6,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 24,
        "name": "Freckles : Skyline",
        "diffuse": "../textures/fabric-freckles-skyline.jpg",
        "repeat": [
            6,
            6
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 24,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Retreat_Fabrics",
            "Cushion",
            "Headboard_Fabric"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": "../textures/fabric-freckles-normal.jpg",
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 30,
        "name": "Hydrangea Holiday : Marine",
        "diffuse": "../textures/fabric-hydrangea_holiday-marine.jpg",
        "repeat": [
            4.8,
            4.8
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 30,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 40,
        "name": "Leaflette : Marine",
        "diffuse": "../textures/fabric-leaflette-marine.jpg",
        "repeat": [
            13.3333333333333,
            13.3333333333333
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 40,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 46,
        "name": "Mix Tape : Marine",
        "diffuse": "../textures/fabric-mix-tape-marine.jpg",
        "repeat": [
            8,
            6
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 46,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Retreat_Fabrics",
            "Cushion",
            "Headboard_Fabric"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 41,
        "name": "Leaflette : Porch",
        "diffuse": "../textures/fabric-leaflette-porch.jpg",
        "repeat": [
            13.3333333333333,
            13.3333333333333
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 41,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 43,
        "name": "Let's Grove : Sage",
        "diffuse": "../textures/fabric-let's_grove-sage.jpg",
        "repeat": [
            4.8,
            4.8
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 43,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 66,
        "name": "Sea Biscuit : Oyster",
        "diffuse": "../textures/fabric-sea_biscuit-oyster.jpg",
        "repeat": [
            7.5,
            7.5
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 66,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 58,
        "name": "Plain Jane : Bright White",
        "diffuse": "../textures/fabric-plain-jane-bright-white.jpg",
        "repeat": [
            10.9090909090909,
            8
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 58,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Retreat_Fabrics",
            "Headboard_Fabric"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 62,
        "name": "Raine : Good Egg",
        "diffuse": "../textures/fabric-raine-good_egg.jpg",
        "repeat": [
            9,
            12
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 62,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion",
            "Headboard_Fabric"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 73,
        "name": "Shore-Bet : Bermuda Beach",
        "diffuse": "../textures/fabric-shore-bet-bermuda-beach.jpg",
        "repeat": [
            4,
            4
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 73,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion",
            "Headboard_Fabric"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 67,
        "name": "Sea Biscuit : Porch",
        "diffuse": "../textures/fabric-sea_biscuit-porch.jpg",
        "repeat": [
            7.5,
            7.5
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 67,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 68,
        "name": "Sea Biscuit : True Blue",
        "diffuse": "../textures/fabric-sea_biscuit-true_blue.jpg",
        "repeat": [
            7.5,
            7.5
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 68,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 42,
        "name": "Let's Grove : Marine",
        "diffuse": "../textures/fabric-let's_grove-marine.jpg",
        "repeat": [
            4.8,
            4.8
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 42,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 70,
        "name": "Shell Game : Lagoon",
        "diffuse": "../textures/fabric-shell_game-lagoon.jpg",
        "repeat": [
            12,
            12
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 70,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 71,
        "name": "Shell Game : Marine",
        "diffuse": "../textures/fabric-shell_game-marine.jpg",
        "repeat": [
            12,
            12
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 71,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 56,
        "name": "Plain Jane : Bisque",
        "diffuse": "../textures/fabric-plain-jane-bisque.jpg",
        "repeat": [
            8,
            12
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 56,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Retreat_Fabrics",
            "Headboard_Fabric"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 44,
        "name": "Lucky Leaf : Marine",
        "diffuse": "../textures/fabric-lucky_leaf-marine.jpg",
        "repeat": [
            19,
            19
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 44,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 72,
        "name": "Shore-Bet : Winter",
        "diffuse": "../textures/fabric-shore_bet-winter.jpg",
        "repeat": [
            2,
            2
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 72,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion",
            "Headboard_Fabric"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 64,
        "name": "Raine : Wheatgrass",
        "diffuse": "../textures/fabric-raine-wheatgrass-w120h120_old.jpg",
        "repeat": [
            30,
            30
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 64,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion",
            "Headboard_Fabric"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 39,
        "name": "Lavishly : Skyline",
        "diffuse": "../textures/fabric-lavishly-skyline.jpg",
        "repeat": [
            8,
            10.9090909090909
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 39,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion",
            "Headboard_Fabric"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 61,
        "name": "Raine : Academy",
        "diffuse": "../textures/fabric-raine-academy.jpg",
        "repeat": [
            5.8252427184466,
            9.21658986175115
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 61,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion",
            "Headboard_Fabric"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 59,
        "name": "Plain Jane : Skyline",
        "diffuse": "../textures/fabric-plain-jane-skyline.jpg",
        "repeat": [
            5.1063829787234,
            6
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 59,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Retreat_Fabrics",
            "Headboard_Fabric"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 60,
        "name": "Plain Jane : Surf",
        "diffuse": "../textures/fabric-plain-jane-surf.jpg",
        "repeat": [
            7,
            5
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 60,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.33,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion",
            "Headboard_Fabric"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 54,
        "name": "Pebble Washed : Sage",
        "diffuse": "../textures/fabric-pebble-washed-sage.jpg",
        "repeat": [
            7.5,
            7.27272727272727
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 54,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion",
            "Cushion",
            "Headboard_Fabric"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 63,
        "name": "Raine : Lagoon",
        "diffuse": "../textures/fabric-raine-lagoon.jpg",
        "repeat": [
            4.8,
            3.42857142857143
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 63,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion",
            "Headboard_Fabric"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 52,
        "name": "Oxford Stripe : Zinnia",
        "diffuse": "../textures/fabric-oxford-zinnia.jpg",
        "repeat": [
            8.5,
            5.2
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 52,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0.4,
        "roughness": 0.8,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Retreat_Fabrics",
            "Cushion",
            "Headboard_Fabric"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 51,
        "name": "Oxford Stripe : Oyster",
        "diffuse": "../textures/fabric-oxford-oyster.jpg",
        "repeat": [
            10,
            6
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 51,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Retreat_Fabrics",
            "Cushion",
            "Headboard_Fabric"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 53,
        "name": "Pebble Washed : Bisque",
        "diffuse": "../textures/fabric-pebble-washed-bisque.jpg",
        "repeat": [
            8.57142857142857,
            8.57142857142857
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 53,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion",
            "Headboard_Fabric"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 50,
        "name": "Oxford Stripe : Marine",
        "diffuse": "../textures/fabric-oxford-marine.jpg",
        "repeat": [
            7.5,
            5
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 50,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Retreat_Fabrics",
            "Cushion",
            "Headboard_Fabric"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 47,
        "name": "Mix Tape : Ryegrass",
        "diffuse": "../textures/fabric-mix-tape-ryegrass.jpg",
        "repeat": [
            8,
            6
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 47,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Retreat_Fabrics",
            "Cushion",
            "Headboard_Fabric"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 48,
        "name": "Mix Tape : Storm",
        "diffuse": "../textures/fabric-mix-tape-skyline.jpg",
        "repeat": [
            8.57142857142857,
            6.31578947368421
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 48,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Retreat_Fabrics",
            "Cushion",
            "Headboard_Fabric"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 45,
        "name": "Mix Tape : Lagoon",
        "diffuse": "../textures/fabric-mix-tape-lagoon.jpg",
        "repeat": [
            8,
            9.6
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 45,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Retreat_Fabrics",
            "Cushion",
            "Headboard_Fabric"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 49,
        "name": "Oxford Stripe : Greenery",
        "diffuse": "../textures/fabric-oxford-grenery.jpg",
        "repeat": [
            6.5,
            3.5
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 49,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Retreat_Fabrics",
            "Cushion",
            "Headboard_Fabric"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 96,
        "name": "Slate Metal",
        "diffuse": "../textures/metal-slate_metal_old.jpg",
        "repeat": [
            8,
            8
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 96,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.34,
        "metalness": 0.1,
        "groups": [
            "Metal_Legs"
        ],
        "clearcoat": 0.39,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 95,
        "name": "Bronzed Metal",
        "diffuse": "../textures/metal-bronzed_metal_old.jpg",
        "repeat": [
            1,
            1
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 95,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.2,
        "metalness": 0.7,
        "groups": [
            "Metal_Legs"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 83,
        "name": "Thatch : Bluebell",
        "diffuse": "../textures/fabric-thatch-bluebell.jpg",
        "repeat": [
            4.55,
            4.44444444444444
        ],
        "offset": [
            -0.15,
            0
        ],
        "uuid": 83,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 86,
        "name": "Tweedy : Bluestone",
        "diffuse": "../textures/fabric-tweedy-bluestone.jpg",
        "repeat": [
            10,
            7.5
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 86,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion",
            "Headboard_Fabric"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 88,
        "name": "Tweet Suite: Porch",
        "diffuse": "../textures/fabric-tweet_suite-porch.jpg",
        "repeat": [
            4.44444444444444,
            4.44444444444444
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 88,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 92,
        "name": "Well-Worn : Vast Sky",
        "diffuse": "../textures/fabric-well-worn-vast_sky.jpg",
        "repeat": [
            24,
            24
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 92,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion",
            "Headboard_Fabric"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 93,
        "name": "Zig Zag : Cloud",
        "diffuse": "../textures/fabric-zig_zag-cloud.jpg",
        "repeat": [
            17.1428571428571,
            17.1428571428571
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 93,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion",
            "Headboard_Fabric"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 94,
        "name": "Zig Zag : Skyline",
        "diffuse": "../textures/fabric-zig_zag-skyline.jpg",
        "repeat": [
            17.1428571428571,
            17.1428571428571
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 94,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion",
            "Headboard_Fabric"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 90,
        "name": "Very Velvet : Sage",
        "diffuse": "../textures/fabric-very_velvet-sage.jpg",
        "repeat": [
            8.43881856540084,
            8.43881856540084
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 90,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion",
            "Headboard_Fabric"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 74,
        "name": "Shore-Bet : Bluebell",
        "diffuse": "../textures/fabric-shore-bet-bluebell.jpg",
        "repeat": [
            4,
            4
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 74,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion",
            "Headboard_Fabric"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 84,
        "name": "Thread Up : Shortcake",
        "diffuse": "../textures/fabric-thread_up-shortcake.jpg",
        "repeat": [
            15,
            15
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 84,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion",
            "Headboard_Fabric"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 82,
        "name": "Simply Soft : Oyster",
        "diffuse": "../textures/fabric-simply-soft-oyster.jpg",
        "repeat": [
            4,
            3
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 82,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion",
            "Headboard_Fabric"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 81,
        "name": "Simply Soft : Marine",
        "diffuse": "../textures/fabric-simply-soft-marine.jpg",
        "repeat": [
            6,
            3.63636363636364
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 81,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion",
            "Headboard_Fabric"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 80,
        "name": "Simply Soft : Cloud",
        "diffuse": "../textures/fabric-simply-soft-cloud.jpg",
        "repeat": [
            4.8,
            3.33333333333333
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 80,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion",
            "Headboard_Fabric"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 79,
        "name": "Shore-Bet : Vast Sky",
        "diffuse": "../textures/fabric-shore-bet-vast-sky.jpg",
        "repeat": [
            4,
            4
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 79,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Retreat_Fabrics",
            "Headboard_Fabric"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 78,
        "name": "Shore-Bet : Surf",
        "diffuse": "../textures/fabric-shore-bet-surf.jpg",
        "repeat": [
            4,
            4
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 78,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Retreat_Fabrics",
            "Headboard_Fabric"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 76,
        "name": "Shore-Bet : Nantucket",
        "diffuse": "../textures/fabric-shore-bet-nantucket.jpg",
        "repeat": [
            4,
            4
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 76,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion",
            "Headboard_Fabric"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 75,
        "name": "Shore-Bet : Bright White",
        "diffuse": "../textures/fabric-shore-bet-bright-white.jpg",
        "repeat": [
            4,
            4
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 75,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion",
            "Headboard_Fabric"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 87,
        "name": "Tweedy : Oyster",
        "diffuse": "../textures/fabric-tweedy-oyster.jpg",
        "repeat": [
            10,
            7.5
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 87,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Retreat_Fabrics",
            "Headboard_Fabric"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 113,
        "name": "Rhubarb",
        "diffuse": null,
        "repeat": [
            1,
            1
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 113,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.8,
        "metalness": 0.2,
        "groups": [
            "Paint_Color",
            "Leg_Finish_Paint_Color"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#cd434b",
        "roughnessMap": "../textures/Wood_Roughness.jpg"
    },
    {
        "id": 105,
        "name": "Gladiola",
        "diffuse": null,
        "repeat": [
            1,
            1
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 105,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.8,
        "metalness": 0.2,
        "groups": [
            "Paint_Color",
            "Leg_Finish_Paint_Color"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#d85040",
        "roughnessMap": "../textures/Wood_Roughness.jpg"
    },
    {
        "id": 112,
        "name": "Porch",
        "diffuse": null,
        "repeat": [
            1,
            1
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 112,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.8,
        "metalness": 0.2,
        "groups": [
            "Paint_Color",
            "Leg_Finish_Paint_Color"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#96cac8",
        "roughnessMap": "../textures/Wood_Roughness.jpg"
    },
    {
        "id": 114,
        "name": "Ryegrass",
        "diffuse": null,
        "repeat": [
            1,
            1
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 114,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.8,
        "metalness": 0.2,
        "groups": [
            "Paint_Color",
            "Leg_Finish_Paint_Color"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#6f9542",
        "roughnessMap": "../textures/Wood_Roughness.jpg"
    },
    {
        "id": 110,
        "name": "Oyster",
        "diffuse": null,
        "repeat": [
            1,
            1
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 110,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.8,
        "metalness": 0.2,
        "groups": [
            "Paint_Color",
            "Leg_Finish_Paint_Color"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#c9cec8",
        "roughnessMap": "../textures/Wood_Roughness.jpg"
    },
    {
        "id": 108,
        "name": "Marine",
        "diffuse": null,
        "repeat": [
            1,
            1
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 108,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.8,
        "metalness": 0.2,
        "groups": [
            "Paint_Color",
            "Leg_Finish_Paint_Color"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#1e4470",
        "roughnessMap": "../textures/Wood_Roughness.jpg"
    },
    {
        "id": 111,
        "name": "Peacock",
        "diffuse": null,
        "repeat": [
            1,
            1
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 111,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.8,
        "metalness": 0.2,
        "groups": [
            "Paint_Color",
            "Leg_Finish_Paint_Color"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#154762",
        "roughnessMap": "../textures/Wood_Roughness.jpg"
    },
    {
        "id": 100,
        "name": "Blackbird",
        "diffuse": null,
        "repeat": [
            1,
            1
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 100,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.8,
        "metalness": 0.2,
        "groups": [
            "Paint_Color",
            "Leg_Finish_Paint_Color"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#21242a",
        "roughnessMap": "../textures/Wood_Roughness.jpg"
    },
    {
        "id": 98,
        "name": "Bermuda Beach",
        "diffuse": null,
        "repeat": [
            1,
            1
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 98,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.8,
        "metalness": 0.2,
        "groups": [
            "Paint_Color",
            "Leg_Finish_Paint_Color"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#fce9df",
        "roughnessMap": "../textures/Wood_Roughness.jpg"
    },
    {
        "id": 99,
        "name": "Bisque",
        "diffuse": null,
        "repeat": [
            1,
            1
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 99,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.8,
        "metalness": 0.2,
        "groups": [
            "Paint_Color",
            "Leg_Finish_Paint_Color"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#d7d0c0",
        "roughnessMap": "../textures/Wood_Roughness.jpg"
    },
    {
        "id": 106,
        "name": "Joy",
        "diffuse": null,
        "repeat": [
            1,
            1
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 106,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.8,
        "metalness": 0.2,
        "groups": [
            "Paint_Color",
            "Leg_Finish_Paint_Color"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#eed067",
        "roughnessMap": "../textures/Wood_Roughness.jpg"
    },
    {
        "id": 103,
        "name": "Bright White",
        "diffuse": null,
        "repeat": [
            1,
            1
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 103,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.8,
        "metalness": 0.2,
        "groups": [
            "Paint_Color",
            "Leg_Finish_Paint_Color"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#f2f3ef",
        "roughnessMap": "../textures/Wood_Roughness.jpg"
    },
    {
        "id": 104,
        "name": "Cloud",
        "diffuse": null,
        "repeat": [
            1,
            1
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 104,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.8,
        "metalness": 0.2,
        "groups": [
            "Paint_Color",
            "Leg_Finish_Paint_Color"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#daebf1",
        "roughnessMap": "../textures/Wood_Roughness.jpg"
    },
    {
        "id": 133,
        "name": "Coconut Husk",
        "diffuse": "../textures/wood-coconut_husk_old.jpg",
        "repeat": [
            8,
            8
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 133,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Retreat_Leg_Finish"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 139,
        "name": "Sea Salt",
        "diffuse": "../textures/wood-sea_salt_old.jpg",
        "repeat": [
            8,
            8
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 139,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Retreat_Leg_Finish"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 140,
        "name": "No Cushion",
        "diffuse": "../textures/paint-color-skyline_old.jpg",
        "repeat": [
            1,
            1
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 140,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Cushion"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 65,
        "name": "Sea Biscuit : Bluestone",
        "diffuse": "../textures/fabric-sea_biscuit-bluestone.jpg",
        "repeat": [
            7.5,
            7.5
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 65,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 16,
        "name": "Clambake: Marine",
        "diffuse": "../textures/fabric-clambake-marine.jpg",
        "repeat": [
            4.44444444444444,
            4.44444444444444
        ],
        "offset": [
            0.1,
            0.47
        ],
        "uuid": 16,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 8,
        "name": "Branch Out : Bermuda Beach",
        "diffuse": "../textures/fabric-branch_out-bermuda_beach.jpg",
        "repeat": [
            4.8,
            4.44444444444444
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 8,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 89,
        "name": "Very Velvet : Marine",
        "diffuse": "../textures/fabric-very_velvet-marine.jpg",
        "repeat": [
            8.43881856540084,
            8.43881856540084
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 89,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 1,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion",
            "Headboard_Fabric"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 91,
        "name": "Washed Out : Vast Sky",
        "diffuse": "../textures/fabric-washed_out-vast_sky.jpg",
        "repeat": [
            17.1428571428571,
            17.1428571428571
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 91,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion",
            "Headboard_Fabric"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 127,
        "name": "Hand Planed Bourbon Cherry",
        "diffuse": "../textures/top-bourbon_cherry_old.jpg",
        "repeat": [
            3,
            3
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 127,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Wood_Top"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 21,
        "name": "Fireworks : Nikko Blue",
        "diffuse": "../textures/fabric-fireworks-nikko_blue.jpg",
        "repeat": [
            26,
            13
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 21,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 137,
        "name": "Natural Maple",
        "diffuse": "../textures/top-maple.jpg",
        "repeat": [
            2.5,
            2.5
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 137,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Chair_Frame"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 128,
        "name": "Natural Cherry",
        "diffuse": "../textures/wood-cherry.jpg",
        "repeat": [
            3,
            3
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 128,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Wood_Top"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 90,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 132,
        "name": "Natural cherry",
        "diffuse": "../textures/wood-cherry.jpg",
        "repeat": [
            2.5,
            2.5
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 132,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Chair_Frame"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 90,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 129,
        "name": "Natural Maple",
        "diffuse": "../textures/top-maple.jpg",
        "repeat": [
            3,
            3
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 129,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Wood_Top"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 90,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 37,
        "name": "Lavishly : Marine",
        "diffuse": "../textures/fabric-lavishly-marine.jpg",
        "repeat": [
            13.3333333333333,
            13.3333333333333
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 37,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion",
            "Headboard_Fabric"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 38,
        "name": "Lavishly : Shortcake",
        "diffuse": "../textures/fabric-lavishly-shortcake.jpg",
        "repeat": [
            8,
            9.79591836734694
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 38,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion",
            "Headboard_Fabric"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 131,
        "name": "Matte Glazed White Oak",
        "diffuse": "../textures/top-white_oak_old.jpg",
        "repeat": [
            3,
            3
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 131,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Wood_Top"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 130,
        "name": "Natural Quarter Sawn White Oak",
        "diffuse": "../textures/top-sawn_oak_old.jpg",
        "repeat": [
            3,
            3
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 130,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Wood_Top"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 136,
        "name": "Limewash",
        "diffuse": "../textures/wood-limewood.jpg",
        "repeat": [
            3,
            75
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 136,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 1,
        "roughness": 1,
        "metalness": 0,
        "groups": [
            "Leg_Finish",
            "Turned_Leg_Finish",
            "Leg_Finish_Paint_Color"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 33,
        "name": "Knotty Loop : Bluestone",
        "diffuse": "../textures/fabric-knotty_loop-bluestone.jpg",
        "repeat": [
            24,
            27.8422273781903
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 33,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion",
            "Headboard_Fabric"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 134,
        "name": "Fruitwood",
        "diffuse": "../textures/wood-fruitwood.jpg",
        "repeat": [
            8,
            8
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 134,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Leg_Finish",
            "Turned_Leg_Finish",
            "Leg_Finish_Paint_Color"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 135,
        "name": "Java",
        "diffuse": "../textures/wood-java.jpg",
        "repeat": [
            8,
            8
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 135,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Leg_Finish",
            "Turned_Leg_Finish",
            "Leg_Finish_Paint_Color"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 55,
        "name": "Plain Jane : Academy",
        "diffuse": "../textures/fabric-plain_jane-academy.png",
        "repeat": [
            8,
            8
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 55,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Retreat_Fabrics",
            "Headboard_Fabric"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 90,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 124,
        "name": "Tomato",
        "diffuse": null,
        "repeat": [
            1,
            1
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 124,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.8,
        "metalness": 0.2,
        "groups": [
            "Paint_Color",
            "Leg_Finish_Paint_Color"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#b5172a",
        "roughnessMap": "../textures/Wood_Roughness.jpg"
    },
    {
        "id": 120,
        "name": "Sprout",
        "diffuse": null,
        "repeat": [
            1,
            1
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 120,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.8,
        "metalness": 0.2,
        "groups": [
            "Paint_Color",
            "Leg_Finish_Paint_Color"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#d5dea5",
        "roughnessMap": "../textures/Wood_Roughness.jpg"
    },
    {
        "id": 121,
        "name": "Storm",
        "diffuse": null,
        "repeat": [
            1,
            1
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 121,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.8,
        "metalness": 0.2,
        "groups": [
            "Paint_Color",
            "Leg_Finish_Paint_Color"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#99a6b6",
        "roughnessMap": "../textures/Wood_Roughness.jpg"
    },
    {
        "id": 119,
        "name": "Sorbet",
        "diffuse": null,
        "repeat": [
            1,
            1
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 119,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.8,
        "metalness": 0.2,
        "groups": [
            "Paint_Color",
            "Leg_Finish_Paint_Color"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#dcf7f5",
        "roughnessMap": "../textures/Wood_Roughness.jpg"
    },
    {
        "id": 125,
        "name": "Vast Sky",
        "diffuse": null,
        "repeat": [
            1,
            1
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 125,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.8,
        "metalness": 0.2,
        "groups": [
            "Paint_Color",
            "Leg_Finish_Paint_Color"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#759dcd",
        "roughnessMap": "/textures/Wood_Roughness.jpg"
    },
    {
        "id": 118,
        "name": "Slate",
        "diffuse": null,
        "repeat": [
            1,
            1
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 118,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.8,
        "metalness": 0.2,
        "groups": [
            "Paint_Color",
            "Leg_Finish_Paint_Color"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#8a8e91",
        "roughnessMap": "/textures/Wood_Roughness.jpg"
    },
    {
        "id": 115,
        "name": "Sage",
        "diffuse": null,
        "repeat": [
            1,
            1
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 115,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.8,
        "metalness": 0.2,
        "groups": [
            "Paint_Color",
            "Leg_Finish_Paint_Color"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#89b788",
        "roughnessMap": "/textures/Wood_Roughness.jpg"
    },
    {
        "id": 141,
        "name": "Painted",
        "diffuse": null,
        "repeat": [
            1,
            1
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 141,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Wood_Top"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": "/textures/Wood_Roughness.jpg"
    },
    {
        "id": 116,
        "name": "Shortcake",
        "diffuse": null,
        "repeat": [
            1,
            1
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 116,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.8,
        "metalness": 0.2,
        "groups": [
            "Paint_Color",
            "Leg_Finish_Paint_Color"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#f7c2b4",
        "roughnessMap": "/textures/Wood_Roughness.jpg"
    },
    {
        "id": 126,
        "name": "Zinnia",
        "diffuse": null,
        "repeat": [
            1,
            1
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 126,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.8,
        "metalness": 0.2,
        "groups": [
            "Paint_Color",
            "Leg_Finish_Paint_Color"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#e8716a",
        "roughnessMap": "../textures/Wood_Roughness.jpg"
    },
    {
        "id": 57,
        "name": "Plain Jane : Bluestone",
        "diffuse": "../textures/fabric-plain-jane-bluestone.jpg",
        "repeat": [
            7.05882352941177,
            6
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 57,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion",
            "Headboard_Fabric"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 69,
        "name": "Shabby Stripes : Bluestone",
        "diffuse": "../textures/fabric-shabby_striped-bluestone.jpg",
        "repeat": [
            6.66666666666667,
            8.57142857142857
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 69,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion",
            "Headboard_Fabric"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 77,
        "name": "Shore-Bet : Sprout",
        "diffuse": "../textures/fabric-shore-bet-sprout.jpg",
        "repeat": [
            4,
            4
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 77,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Cushion",
            "Headboard_Fabric"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 85,
        "name": "Tweedy : Bisque",
        "diffuse": "../textures/fabric-tweedy-bisque.jpg",
        "repeat": [
            10,
            8.5
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 85,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Retreat_Fabrics",
            "Headboard_Fabric"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 23,
        "name": "Freckles : Greenery",
        "diffuse": "../textures/fabric-freckles-greenery.jpg",
        "repeat": [
            6,
            6
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 23,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Upholstery",
            "Retreat_Fabrics",
            "Cushion",
            "Headboard_Fabric"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": "../textures/fabric-freckles-normal.jpg",
        "color": "#ffffff",
        "roughnessMap": null
    },
    {
        "id": 102,
        "name": "Bluestone",
        "diffuse": null,
        "repeat": [
            1,
            1
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 102,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.8,
        "metalness": 0.2,
        "groups": [
            "Paint_Color",
            "Leg_Finish_Paint_Color"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#77a0ab",
        "roughnessMap": "/textures/Wood_Roughness.jpg"
    },
    {
        "id": 107,
        "name": "Lagoon",
        "diffuse": null,
        "repeat": [
            1,
            1
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 107,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.8,
        "metalness": 0.2,
        "groups": [
            "Paint_Color",
            "Leg_Finish_Paint_Color"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#00798e",
        "roughnessMap": "/textures/Wood_Roughness.jpg"
    },
    {
        "id": 109,
        "name": "Milk",
        "diffuse": null,
        "repeat": [
            1,
            1
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 109,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.8,
        "metalness": 0.2,
        "groups": [
            "Paint_Color",
            "Leg_Finish_Paint_Color"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#fffdf1",
        "roughnessMap": "/textures/Wood_Roughness.jpg"
    },
    {
        "id": 117,
        "name": "Skyline",
        "diffuse": null,
        "repeat": [
            1,
            1
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 117,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.8,
        "metalness": 0.2,
        "groups": [
            "Paint_Color",
            "Leg_Finish_Paint_Color"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#94b7c0",
        "roughnessMap": "/textures/Wood_Roughness.jpg"
    },
    {
        "id": 123,
        "name": "Surf",
        "diffuse": null,
        "repeat": [
            1,
            1
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 123,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.8,
        "metalness": 0.2,
        "groups": [
            "Paint_Color",
            "Leg_Finish_Paint_Color"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#60959c",
        "roughnessMap": "/textures/Wood_Roughness.jpg"
    },
    {
        "id": 122,
        "name": "Sun",
        "diffuse": null,
        "repeat": [
            1,
            1
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 122,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.8,
        "metalness": 0.2,
        "groups": [
            "Paint_Color",
            "Leg_Finish_Paint_Color"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffe39e",
        "roughnessMap": "/textures/Wood_Roughness.jpg"
    },
    {
        "id": 101,
        "name": "Bluebell",
        "diffuse": null,
        "repeat": [
            3,
            3
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 101,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.8,
        "metalness": 0.2,
        "groups": [
            "Paint_Color",
            "Leg_Finish_Paint_Color"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#c4ddce",
        "roughnessMap": "/textures/Wood_Roughness.jpg"
    },
    {
        "id": 97,
        "name": "Academy",
        "diffuse": null,
        "repeat": [
            1,
            1
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 97,
        "visible": true,
        "aoMapIntensity": 1,
        "normal": 0,
        "roughness": 0.8,
        "metalness": 0.2,
        "groups": [
            "Paint_Color",
            "Leg_Finish_Paint_Color"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#313a4b",
        "roughnessMap": "/textures/Wood_Roughness.jpg"
    },
    {
        "id": 138,
        "name": "Nordic",
        "diffuse": "../textures/wood-nordic.jpg",
        "repeat": [
            10,
            10
        ],
        "offset": [
            0,
            0
        ],
        "uuid": 138,
        "visible": true,
        "aoMapIntensity": 0,
        "normal": 0,
        "roughness": 0.73,
        "metalness": 0,
        "groups": [
            "Leg_Finish",
            "Turned_Leg_Finish",
            "Leg_Finish_Paint_Color"
        ],
        "clearcoat": 0,
        "clearcoatRoughness": 0,
        "rotation": 0,
        "normalMap": null,
        "color": "#ffffff",
        "roughnessMap": null
    }
]